import {
  APP_ERROR,
  REHYDRATION_COMPLETE,
  ROUTE_CHANGE,
  ON_BACK_BUTTON_PRESS,
  RESET_ROUTE_CHANGE_STATE,
  UPDATE_APP_LOCATION,
  OPTIMIZE_ACTIVATE,
  CLEAR_APP_ERRORS,
  CLOSE_MODAL,
  CLOSE_ONE_OFF_MODAL,
} from "../types/App";

export const rehydrationComplete = (history) => {
  return {
    type: REHYDRATION_COMPLETE,
    history,
  };
};

export const appError = (errors) => {
  return {
    type: APP_ERROR,
    errors,
  };
};

export const clearAppErrors = () => {
  return { type: CLEAR_APP_ERRORS };
};

export const signalRouteChange = (pathname, query) => {
  return (dispatch) => {
    dispatch({
      type: ROUTE_CHANGE,
      pathname,
      query,
    });
  };
};

export const signalBackButtonPress = (location) => {
  return (dispatch) => {
    dispatch({
      type: ON_BACK_BUTTON_PRESS,
      location,
    });
  };
};

export const updateAppLocation = ({ pathname, query }) => {
  return {
    type: UPDATE_APP_LOCATION,
    pathname,
    query,
  };
};

export const resetRouteChangeState = () => {
  return (dispatch) => {
    dispatch({ type: RESET_ROUTE_CHANGE_STATE });
  };
};

export const activateGoogleOptimize = () => {
  return { type: OPTIMIZE_ACTIVATE };
};

export const closeModal = () => ({ type: CLOSE_MODAL });

export const closeOneOffModal = ({ modalKey }) => ({
  type: CLOSE_ONE_OFF_MODAL,
  modalKey,
});

const AppActions = {
  rehydrationComplete,
  appError,
  activateGoogleOptimize,
  closeModal,
  closeOneOffModal,
};

export default AppActions;
